import { render, staticRenderFns } from "./RequestOrderPayment.vue?vue&type=template&id=895c6f7c&scoped=true"
import script from "./RequestOrderPayment.vue?vue&type=script&lang=js"
export * from "./RequestOrderPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895c6f7c",
  null
  
)

export default component.exports